<template>
  <div>
    <div v-if="!loading" class="customer-presentation">
      <p
        class="mb-2"
        v-html="$t('connectWith', { email: online_account.email })"
      />
      <div>
        <!-- Information -->
        <dt>
          {{ $t("myInformation") }}
        </dt>
        <dd>
          {{ online_account.customer.firstname }}
          {{ online_account.customer.lastname }}<br />
          {{ $t("born") }}
          {{ dateOfBirth(online_account.customer.date_of_birth) }}
        </dd>

        <!-- Contact -->
        <dt>
          {{ $t("contact") }}
        </dt>
        <dd>
          <b-icon icon="cellphone" size="is-small" class="mr-1" />
          {{ online_account.customer.phone }}<br />
          <b-icon icon="at" size="is-small" class="mr-1" />
          {{ online_account.customer.email }}
        </dd>

        <!-- Address -->
        <dt>
          {{ $t("address") }}
        </dt>
        <dd>
          {{ online_account.customer.address }}<br />
          {{ online_account.customer.zipcode }}
          {{ online_account.customer.city }}
        </dd>
      </div>

      <div class="text-right">
        <b-button
          type="is-link is-light mr-2"
          rounded
          @click="logout"
        >
          {{ $t("disconnect") }}
        </b-button>
        <b-button
          class="loadable-button"
          type="is-primary is-light"
          rounded
          @click="checkout"
        >
          {{ $t("checkout") }}
        </b-button>
      </div>
    </div>

    <spinner v-if="loading" />
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { HelpersMixin } from "@/mixins/HelpersMixin";
import { CartMixin } from "@/mixins/CartMixin";
import cug from "@/services/cug";
import VueI18n from "vue-i18n";
import store from "@/store";
import Spinner from "../../../shared/Spinner";
import moment from "@/services/momentjs";

export default {
  store,
  components: { Spinner },
  name: "CartCustomerAccount",
  mixins: [LocaleMixin, HelpersMixin, CartMixin],

  props: {
    errorReport: Function
  },

  data() {
    return {
      loading: true,
      name: null,

      online_account: {
        uuid: null,
        email: null,
        customer: null,
        customers: []
      }
    };
  },

  computed: {
    isLoggedIn () {
      return store.getters["auth/isLoggedIn"];
    }
  },

  beforeMount () {
    this.getAccount();
  },

  methods: {
    getAccount () {
      if (this.isLoggedIn) {
        this.loading = true;
        cug
          .getAccount()
          .then(resp => {
            this.online_account.uuid = resp.data.uuid;
            this.online_account.email = resp.data.email;
            this.online_account.customers = resp.data.customers;
            this.online_account.customer =
              this.getCurrentCustomer() || resp.data.customers[0];
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    getCurrentCustomer () {
      let customerFound = null;
      for (const customer of this.online_account.customers) {
        if (customer.id === store.getters["auth/getCurrentCustomerId"]) {
          customerFound = customer;
        }
      }
      return customerFound;
    },

    dateOfBirth (date) {
      return moment(date).format("LL");
    },

    logout () {
      store.dispatch("auth/logout");
    },

    checkout () {
      const trackers = this.getAnalyticsTrackers();

      this.errorMessage = [];
      let data = {
        cart: {
          online_account: {
            uuid: this.online_account.uuid,
            customer_id: this.online_account.customer.id
          },
          trackers
        }
      };

      this.loadButton(true);
      store
        .dispatch("cart/checkout", data)
        .then(resp => {
          if (resp.data.payment) {
            let paymentUrl = resp.data.payment.url;
            this.gotToPaymentPage(paymentUrl);
          } else {
            this.goToConfirmationPage(resp.data.purchase.reference);
          }
        })
        .catch(err => {
          this.errorReport(err);
        })
        .finally(() => {
          this.loadButton(false);
        });
    }
  },

  // Translate component
  mounted () {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        connectWith:
          "You are connected with <strong>%{email}</strong> account, the following information will be used:",
        myInformation: "My informations",
        born: "Born",
        contact: "Contact",
        address: "Address",
        checkout: "Checkout",
        disconnect: "Disconnect"
      },
      fr: {
        connectWith:
          "Vous êtes connecté·e au compte <strong>%{email}</strong>, les informations suivantes vont être utilisées :",
        myInformation: "Mes informations",
        born: "Né·e le",
        contact: "Contact",
        address: "Adresse",
        checkout: "Procéder au paiement",
        disconnect: "Me déconnecter"
      }
    }
  })
};
</script>

<style lang="scss">
.customer-presentation {
  dt {
    font-weight: bold;
  }
  dd {
    padding-left: 1em;
    margin-bottom: 1em;
    i {
      color: #7b7b7b;
    }
  }
}
</style>
